import { render } from "./modal-sav.vue?vue&type=template&id=8881892e"
import script from "./modal-sav.vue?vue&type=script&lang=js"
export * from "./modal-sav.vue?vue&type=script&lang=js"

import "./modal-sav.vue?vue&type=style&index=0&id=8881892e&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__